import React, { useState } from 'react'
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Stack, TextField, Typography } from '@mui/material'
import api from 'utils/api'
import { errorMessage, operationKey } from './shared'
import { readable } from './presentation'
import NotificationDeliveryNotice from './NotificationDeliveryNotice'

export default function OfferModerationDialog({ offer, action, onClose, onSuccess, onConflict }) {
  const [reason, setReason] = useState(action === 'DISABLE' ? 'TERMS_VIOLATION' : 'REVIEW_RESOLVED')
  const [comment, setComment] = useState('')
  const [key, setKey] = useState(operationKey)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)
  const submit = async () => {
    setBusy(true); setError(null)
    try {
      const result = await api.patch(`/admin/offers/${offer.offer_id}/moderation`, { action, reasonCode: reason, comment, version: offer.moderation.version }, { headers: { 'Idempotency-Key': key } })
      await onSuccess(result)
    } catch (e) { setError(e); if (e.code === 'VERSION_CONFLICT') onConflict?.() } finally { setBusy(false) }
  }
  return <Dialog open onClose={busy ? undefined : onClose} fullWidth maxWidth="sm">
    <DialogTitle>{readable(action)}</DialogTitle><DialogContent><Stack gap={2} pt={1}>
      <Typography fontWeight={600}>{offer.title || offer.headline_1}</Typography>
      <Typography>{action === 'DISABLE' ? 'Stop public exposure and make this offer view-only. Editing, copying and activation will be blocked.' : 'Restore only the state changed by this moderation action. The offer may return online if still eligible. Expiry, independent pauses, business restrictions and budget limits remain in effect. Restoring a disabled offer does not clear an earlier review.'}</Typography>
      <TextField select label="Reason" value={reason} onChange={e => { setReason(e.target.value); setKey(operationKey()) }}>
        <MenuItem value="TERMS_VIOLATION">Terms violation</MenuItem><MenuItem value="REVIEW_RESOLVED">Review resolved</MenuItem><MenuItem value="OWNER_REQUEST">Owner request</MenuItem><MenuItem value="OTHER">Other</MenuItem>
      </TextField>
      <TextField multiline rows={3} label="Additional context" value={comment} inputProps={{ maxLength: 1000 }} onChange={e => { setComment(e.target.value); setKey(operationKey()) }} />
      <NotificationDeliveryNotice />
      {error && <Alert severity="error">{errorMessage(error)}</Alert>}
    </Stack></DialogContent><DialogActions><Button disabled={busy} onClick={onClose}>Cancel</Button><Button variant="contained" disabled={busy || (reason === 'OTHER' && !comment.trim())} onClick={submit}>Confirm change</Button></DialogActions>
  </Dialog>
}
